import React from 'react';
import styled from 'styled-components';
import { Image } from 'react-bootstrap';
import { blockCustomProps } from '../../user/HomepageStarterEmail/styled';

// Define element styles for the component
const StyledLogo = styled(Image).withConfig({
  shouldForwardProp: blockCustomProps
})`
  left: 30px;
  margin: auto;
  height: ${({customHeight}) =>  customHeight ? `${customHeight}px` : '100px' };;
  margin: ${({customPosition}) =>  customPosition ? `20px` : 'auto' };
  position: ${({customPosition}) =>  customPosition ? customPosition : 'absolute' };
  top: 20px;
  max-width: 350px;
  object-fit: contain;
  aspect-ratio: 4;

  @media (max-width: 767px) {
    height: ${({customHeight}) =>  customHeight ? `${customHeight}px` : '100px' };;
    top: 10px;
    width: 250px;
  }
`;

/**
 * Logo component
 * @component
 * @returns
 */
export const Logo = ({ ...props }) => {
  return <StyledLogo { ...props } />;
};
